module.exports = __webpack_public_path__ + "static/media/arrow-to-start.7097e74e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/arrow-to-start.svg
// module id = 120
// module chunks = 0